/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react'
import { Button } from 'antd'
import { useIntl } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { PieChart } from 'react-minimal-pie-chart';
import { fetchDashboardJobConfirmations, fetchDashboardJobStatistic } from '../../../../_redux/features/dashboard/dashboardSlice'

const chartSize = 70
const chartLine = 11
const chartRotate = 145
const colors = ['#E4E6EF','#00FF00','#FF0000', '#0000FF']


const JobConfirmationsDashboard: FC = () => {
    const intl = useIntl()
    const dispatch = useDispatch<any>()
    const navigate = useNavigate()
    const { jobStatistic, isLoading } = useSelector((state: any) => state.dashboard)
    const [statistics, setStatistics] = useState<any>([
        { name: 'Değerlendirmede', count: 0 },
        { name: 'Onaylandı', count: 0 },
        { name: 'Reddedildi', count: 0 }
    ]);
    useEffect(() => { dispatch(fetchDashboardJobStatistic()) }, [])
    useEffect(() => {
        setStatistics(jobStatistic.map(x => ({ name : intl.formatMessage({id: x.name}), count: x.count})));
    }, [jobStatistic]);
    return (
        <div className={`card card-flush col-12 `}>
            <div className='d-flex card-header border-0 pt-5'>
                <div className='col-6'>
                    <h3 className=' card-title align-items-start flex-column'>
                        <span className='card-label fw-bold fs-3 mb-1'>{intl.formatMessage({ id: 'CHARTS.JOBAPPROVE' })}</span>
                    </h3>
                </div>

                <div className='col-6 '>
                    <Button className='float-end' onClick={() => navigate("/company-and-jobs/jobs")}>{intl.formatMessage({ id: 'CHARTS.VIEW' })}</Button>
                </div>

            </div>

            <div className='card-body  d-flex flex-wrap align-items-center'>
                <div className='d-flex '>
                    <PieChart style={{ height: "100", width: "100" }}
                         data={statistics.map((x,index) => { return { color: colors[index], value:x.count, key:index, title:x.name}} )}
                    />
                </div>

                <div className='ms-4  d-flex flex-column content-justify-center flex-row-fluid'>
                    {
                        statistics?.map((x, index) => 
                        {
                            return(
                                <div className='d-flex fw-semibold align-items-center' key={index}>
                                    <div
                                        className='bullet w-8px h-3px rounded-2 me-3'
                                        style={{ backgroundColor: colors[index] }}
                                    ></div>
                                    <div className='text-gray-500 flex-grow-1 me-4'>{x.name}</div>
                                    <div className=' fw-bolder text-gray-700 text-xxl-end'>{x.count}</div>
                                </div>  
                            )
                        })
                    }
                </div>
            </div>
        </div>
    )
}
const initChart = function (
    chartSize: number = 70,
    chartLine: number = 11,
    chartRotate: number = 145
) {
    const el = document.getElementById('kt_card_widget_17_chart')
    if (!el) {
        return
    }
    el.innerHTML = ''

    var options = {
        size: chartSize,
        lineWidth: chartLine,
        rotate: chartRotate,
        //percent:  el.getAttribute('data-kt-percent') ,
    }

    const canvas = document.createElement('canvas')
    const span = document.createElement('span')

    // @ts-ignore
    if (typeof G_vmlCanvasManager !== 'undefined') {
        // @ts-ignore
        G_vmlCanvasManager.initElement(canvas)
    }

    const ctx = canvas.getContext('2d')
    canvas.width = canvas.height = options.size

    el.appendChild(span)
    el.appendChild(canvas)

    // @ts-ignore
    ctx.translate(options.size / 2, options.size / 2) // change center
    // @ts-ignore
    ctx.rotate((-1 / 2 + options.rotate / 180) * Math.PI) // rotate -90 deg

    //imd = ctx.getImageData(0, 0, 240, 240);
    const radius = (options.size - options.lineWidth) / 2

    const drawCircle = function (color: string, lineWidth: number, percent: number) {
        percent = Math.min(Math.max(0, percent || 1), 1)
        if (!ctx) {
            return
        }

        ctx.beginPath()
        ctx.arc(0, 0, radius, 0, Math.PI * 2 * percent, false)
        ctx.strokeStyle = color
        ctx.lineCap = 'round' // butt, round or square
        ctx.lineWidth = lineWidth
        ctx.stroke()
    }

    // Init 2
    drawCircle('#E4E6EF', options.lineWidth, 100 / 100)
    drawCircle('#FF0000', options.lineWidth, 100 / 150)
    drawCircle('#00FF00', options.lineWidth, 100 / 250)
}

export default JobConfirmationsDashboard;
